import React from 'react'

import { useTranslation } from 'react-i18next'

import Tooltip from '@components/shared/Tooltip'

const OfficialBadge: React.FC = () => {
  const { t } = useTranslation()
  return (
    <Tooltip arrow placement="bottom" content={t('content.originalWork')}>
      <i className="nf-icon nf-original text-orange text-lg -mt-0.5" />
    </Tooltip>
  )
}
export default OfficialBadge
